const course_participation = {
  type: "stacked",
  title: "Online Learning Course Participation Over Time",
  source: "Source: IMF, Institute for Capacity Development.",
  data: {
    labels: [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    datasets: [
      {
        label: "Course offerings by fiscal year",
        type: "bar",
        yAxesID: "y-axis-1",
        data: [2, 6, 13, 19, 22, 27, 44, 53, 105],
        backgroundColor: "#0084BC",
        borderColor: "#0084BC",
        borderWidth: 1,
        order: 2,
      },
      {
        type: "line",
        label: "Total active participants",
        yAxisID: "y-axis-2",
        backgroundColor: "rgba(255,255,255,0.5)",
        data: [1296, 10622, 21922, 35620, 45796, 60173, 88951, 112904, 140000],
        borderColor: "#F1AF2A",
        borderWidth: 2,
        order: 1,
      },
    ],
  },
  options: {
    height: "large",
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          id: "y-axis-1",
          position: "left",
          type: "linear",
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: "Course offerings",
          },
        },
        {
          id: "y-axis-2",
          position: "right",
          type: "linear",
          ticks: {
            max: 140000,
            stepSize: 20000,
            display: true,
            beginAtZero: true,
            callback: function (value, index, values) {
              if (parseInt(value) >= 1000) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              } else {
                return value
              }
            },
          },
          scaleLabel: {
            display: true,
            labelString: "Active participants",
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      position: "bottom",
      labels: {
        boxWidth: 10,
        padding: 20,
      },
    },
  },
}

export default course_participation
